export default __webpack_public_path__ + "static/appliances_w.471e2759758203238f14dddf80436117.png";